import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _OperationType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectTypeProcees } from "../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import usePaginator from "../../../theme/Component/usePaginator";



export const OperationType = () => {

    const OperationType = useDataBean(_OperationType);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [ProcessType, setProccesType] = useState<number>(null)
    const [regexStr, setregexStr] = useState<string>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    const [records, setRecords] = useState<number>(15);

    useEffect(() => {
        getLista();
    }, [ProcessType, regexStr, paginador.page, records])

    const getLista = () => {

        OperationType.instance.getOperationTypeCatalog(ProcessType, regexStr, paginador.page, records).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (records));
                    paginador.setRegiPerPage(records)

                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        OperationType.setBean({
            ProcessType: OperationType.bean.ProcessType,
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        OperationType.deleteItemVoid(OperationType.bean.IDOperationType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        OperationType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDOperationType', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${OperationType.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }





    return (
        <BasicPage titulo="Tipos de Operación">
            <div className="row">
                <div className="col-md-6">
                    <SelectTypeProcees label='Tipo de Proceso' idSelector={ProcessType} onChange={(e: any) => { setProccesType(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={OperationType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={records}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={OperationType.bean.ProcessType} onChange={(e) => { OperationType.setBean({ ...OperationType.bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={OperationType.bean.Code} onChange={(e) => { OperationType.setBean({ ...OperationType.bean, "Code": parseFloat(e.target.value) }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={OperationType.bean.Name} onChange={OperationType.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={OperationType.bean.Description} onChange={OperationType.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {OperationType.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}